// extracted by mini-css-extract-plugin
export var counterDivider = "InNumbers-module--counter-divider--b9f27";
export var dark = "InNumbers-module--dark--579a5";